'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('./Utils');

var _SubContent = require('./Utils/SubContent');

var _SubContent2 = _interopRequireDefault(_SubContent);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_ENTER = 13;
var KEY_UP = 38;
var KEY_DOWN = 40;
var KEY_ESCAPE = 27;

function createHighlightNode(text, highlight) {
    var index = text.toLowerCase().indexOf(highlight);

    // Extract the prematch, match and postmatch from the plain label
    var prematch = text.slice(0, index);
    var match = text.slice(index, index + highlight.length);
    var postmatch = text.slice(index + highlight.length);

    // Create some JSX markup to wrap the match in a highlighting span
    return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
            'span',
            null,
            prematch
        ),
        _react2.default.createElement(
            'span',
            { className: 'control-select__option--highlighted' },
            match
        ),
        _react2.default.createElement(
            'span',
            null,
            postmatch
        )
    );
}

/*
 * Select box with drop down scrollable, and can be navigated with up/down arrow keys.
 */

var Select = function (_Component) {
    _inherits(Select, _Component);

    function Select() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Select);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            // The bottom position of the tooltip.
            tooltipPosition: null,

            // The value currently inputted by the user in the text field.
            inputValue: null,

            // Whether the field is currently open due to user interaction.
            open: false,

            // Tnis applies only when a search function is provided. Stores whether we are currently
            // waiting for an async search response.
            searching: false,

            // Options from props.options pre-categorised by the category key's value.
            categorisedOptions: {},

            // The currently-focussed option. (Which may differ from value in props is user has used up/down.)
            focussedOption: null,

            // The number of actual options after applying filtering.
            numFilteredOptions: 0
        }, _this.mounted = false, _this.searchTimeout = null, _this.blurTimeout = null, _this.inputId = _this.props.id || (0, _Utils.generateId)(_this.props.name), _this.textInput = null, _this.formControl = null, _this.optionList = null, _this.storeTextInputRef = function (ref) {
            _this.textInput = ref;

            if (_this.props.innerRef) {
                _this.props.innerRef(ref);
            }
        }, _this.storeFormControlRef = function (ref) {
            _this.formControl = ref;

            var tooltipPosition = null;

            if (ref) {
                tooltipPosition = ref.getBoundingClientRect().height;
            }

            _this.setState({ tooltipPosition: tooltipPosition });
        }, _this.storeOptionListRef = function (ref) {
            return _this.optionList = ref;
        }, _this.resolveFilteredOptions = function (cb) {
            var filteredOptions = _this.getFilteredOptions();

            _this.setState({
                numFilteredOptions: filteredOptions.length,
                categorisedOptions: _this.categoriseOptions(filteredOptions, _this.props.categoriseBy),
                focussedOption: _this.getSelectedOption(filteredOptions)
            }, cb);
        }, _this.getSelectedOption = function (options) {
            var option = options.find(function (option) {
                return option.value === _this.props.value;
            });

            if (!option && options.length) {
                option = options[0];
            }

            return option;
        }, _this.handleInputChanged = function (e) {
            var inputValue = e.target.value;

            _this.setState({ inputValue: inputValue }, _this.resolveFilteredOptions);

            // If a search function is provided then we need to call it with the value as a query argument
            if (_this.props.searchOptions) {
                if (inputValue && inputValue.length >= _this.props.minCharSearch) {
                    // the following debounces the search function with the specified timeout (default 250ms)
                    if (_this.searchTimeout) {
                        clearTimeout(_this.searchTimeout);
                    }

                    _this.searchTimeout = setTimeout(function () {
                        var p = _this.props.searchOptions(inputValue);

                        // If we got a promise back from searchOptions, add a finally callback to it
                        // that sets our state's "searching" to false. After all, if the promise
                        // resolves (or rejects), searching is done.
                        if (p && p.finally) {
                            if (_this.mounted) {
                                _this.setState({ searching: true });
                            }

                            p.finally(function () {
                                // Mounted check just in case the component was unmounted while the
                                // search promise was waiting.
                                if (_this.mounted) {
                                    _this.setState({ searching: false });
                                }
                            });
                        }
                    }, _this.props.searchDebounceMs);
                }
            }
        }, _this.handleInputMousePressedDown = function () {
            // If we're open and the text input is clicked, close dropdown.
            if (_this.state.open) {
                // Set an immediate timeout because if we blue while the mousedown event is firing, the
                // text input will just regain focus.
                setTimeout(function () {
                    _this.textInput && _this.textInput.blur();
                });
            }
        }, _this.handleComponentFocussed = function (e) {
            clearTimeout(_this.blurTimeout);

            _this.openDropdown();
        }, _this.handleComponentBlurred = function (e) {
            // @see https://reactjs.org/docs/accessibility.html#mouse-and-pointer-events for why we set
            // a timeout in blur and clear it in focus.
            _this.blurTimeout = setTimeout(_this.closeDropdown);
        }, _this.openDropdown = function () {
            if (!_this.state.open) {
                _this.textInput && _this.textInput.select();

                _this.setState({ open: true });

                _this.resolveFilteredOptions(_this.setOptionScrollValue);

                _this.props.handleFocus && _this.props.handleFocus();
            }
        }, _this.closeDropdown = function () {
            _this.setState({
                inputValue: null,
                focussedOption: null,
                searching: false,
                open: false
            });

            _this.textInput && _this.textInput.blur();

            _this.props.handleBlur && _this.props.handleBlur();
        }, _this.clearSelection = function () {
            return _this.props.value && _this.props.updateValue(_defineProperty({}, _this.props.name, null));
        }, _this.handleInputKeyDown = function (e) {
            switch (e.keyCode) {
                case KEY_ENTER:
                    // If the dropdown is currently showing, we don't want pressing enter in the input
                    // to actually submit any form that the Select component is part of, but instead
                    // just select the focussed option. So let's prevent the default action in that
                    // case.
                    if (_this.state.open) {
                        e.preventDefault();
                    }

                    _this.selectFocussedOption();
                    break;

                case KEY_UP:
                    _this.focusPreviousOption();
                    break;

                case KEY_DOWN:
                    _this.focusNextOption();
                    break;

                case KEY_ESCAPE:
                    _this.closeDropdown();
                    break;

                default:
                    break;
            }
        }, _this.getOptionLabelForValue = function (value) {
            var allOptions = _this.props.options.concat(_this.props.defaultOptions);

            var option = allOptions.find(function (option) {
                return option.value === value;
            });

            if (option) {
                return option.label;
            }

            return null;
        }, _this.getFilteredOptions = function () {
            if (_this.state.inputValue && !_this.props.searchOptions) {
                // If we have a search input value (and don't have an external search provider), try to
                // filter the options we have.
                var options = [];

                var search = _this.state.inputValue.toString().toLowerCase();

                // If getFilteredOptions was provided, use that to filter the results down. Otherwise,
                // just do a simple search-within-the-label.
                if (_this.props.getFilteredOptions) {
                    options = _this.props.getFilteredOptions(search);
                } else {
                    options = _this.props.options.filter(function (option) {
                        return _this.props.filterStartsWithOnly ? option.label.toLowerCase().indexOf(search) === 0 : option.label.toLowerCase().indexOf(search) !== -1;
                    });
                }

                // Augment the label to be either the richlabel if it exists, or a simple highlighted
                // version of the standard label if not.
                return options.map(function (option) {
                    // Create a new option with highlighted match if no rich label is present
                    return _extends({}, option, {
                        label: option.richLabel ? _react2.default.cloneElement(option.richLabel, { match: search }) : createHighlightNode(option.label, search)
                    });
                });
            }

            // If no search input value, just augment the label to be either the richlabel if it
            // exists, or  the standard label if not.
            return _this.props.options.map(function (option) {
                return _extends({}, option, {
                    label: option.richLabel || option.label
                });
            });
        }, _this.focusNextOption = function () {
            _this.setState({
                focussedOption: _this.getNextOption()
            }, _this.setOptionScrollValue);
        }, _this.focusPreviousOption = function () {
            _this.setState({
                focussedOption: _this.getPreviousOption()
            }, _this.setOptionScrollValue);
        }, _this.selectFocussedOption = function () {
            if (!(_this.state.open && _this.state.focussedOption)) {
                return;
            }

            // While the state's focussedOption is an option object, it will have been mutated sightly
            // from what was passed in props. So here we make sure to pick the 'original' props option
            // out.
            var option = _this.props.options.find(function (option) {
                return option.value === _this.state.focussedOption.value;
            });

            // And just on the offchance we didn't find the option, let's be cautious...
            if (option) {
                _this.assignValue(option);
            }
        }, _this.setOptionScrollValue = function () {
            var option = _this.state.focussedOption;

            // By default, let's go to the top.
            var scrollTo = 0;

            if (option && _this.state.numFilteredOptions) {
                // Get all "options" from the descendents of the option list
                var item = _this.optionList.querySelector('.control-select__option[data-value="' + option.value + '"]');

                if (item) {
                    // If item if the first option in a categorisation group, actually set the scroll
                    // value to the group itself.

                    var prev = item.previousElementSibling;

                    if (prev && Array.from(prev.classList).includes('control-select__group-heading')) {
                        scrollTo = item.parentNode.offsetTop;
                    } else {
                        scrollTo = item.offsetTop;
                    }
                }
            }

            _this.optionList.scrollTop = scrollTo;
        }, _this.getNoOptionPlaceholder = function () {
            // If we are currently searching, return the "searching..." placeholder.
            if (_this.state.searching === true) {
                return _this.props.searchingPlaceholder;
            }

            // If we have a search function, and some search text, return the "no results" placeholder.
            if (_this.props.searchOptions && _this.state.inputValue && _this.state.inputValue.length) {
                return _this.props.noResultsPlaceholder;
            }

            // Anythng else can safely have the "no results" placeholder.
            return _this.props.noOptionPlaceholder;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Select, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.resolveFilteredOptions();

            this.mounted = true;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var newState = {};

            // If the value has changed, refresh our idea of which option should be focussed.
            if (nextProps.value !== this.props.value) {
                // Also, if the value is empty, we should clear the 'selected text' value.
                if (!nextProps.value) {
                    newState.inputValue = null;
                }
            }

            this.setState(newState, function () {
                _this2.resolveFilteredOptions();
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.mounted = false;
        }

        // Refs


        /*
         * Find the selected option from the current value, or default to the first option otherwise.
         */

    }, {
        key: 'handleOptionClicked',
        value: function handleOptionClicked(option) {
            this.assignValue(option);

            if (!this.props.closeOnSelect) {
                this.textInput && this.textInput.focus();
            }
        }
    }, {
        key: 'handleOptionKeyPressed',
        value: function handleOptionKeyPressed(option, e) {
            if (e.which === KEY_ENTER) {
                this.handleOptionClicked(option);
            }
        }
    }, {
        key: 'assignValue',
        value: function assignValue(option) {
            if (this.props.closeOnSelect) {
                this.closeDropdown();
            }

            this.props.updateValue(_defineProperty({}, this.props.name, option.value));
        }

        /*
         * Given a value, get the label for that value.
         */


        /*
         * Compile a list of all options filtered by the search text.
         */

    }, {
        key: 'categoriseOptions',
        value: function categoriseOptions(options, categoriseBy) {
            if (categoriseBy) {
                // This will store all options in their categories
                var categorisedOptions = {
                    __NONE__: []
                };

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var option = _step.value;

                        var category = (0, _Utils.getProperty)(option, categoriseBy);

                        if (!(category in categorisedOptions)) {
                            categorisedOptions[category] = [];
                        }

                        categorisedOptions[category].push(option);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return categorisedOptions;
            }

            return {
                __NONE__: [].concat(_toConsumableArray(options))
            };
        }
    }, {
        key: 'getNextOption',
        value: function getNextOption() {
            // We store the first option visited so that if the last option is the one that matches the
            // current one, the next option is the first. Or if the option is not found, the first
            // option seems like a sensible 'next' option.
            var first = null;

            // As soon as we visit the currently-selected value, we say the next one visited is the one
            // we want. This variable helps us do that.
            var selectNext = false;

            // Iterate through all options in category order in order to find the current one and select
            // the next one visited.
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.values(this.state.categorisedOptions)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var options = _step2.value;
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = options[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var option = _step3.value;

                            // If no 'first option' exists, set it here.
                            if (!first) {
                                first = option;
                            }

                            // If we already found the current one, this will be true telling us to return the
                            // 'next' one. So do so.
                            if (selectNext) {
                                return option;
                            }

                            // Otherwise, keep searching for the curretly-selected option. If found, set
                            // selectNext to true,
                            if (this.state.focussedOption && option.value === this.state.focussedOption.value) {
                                selectNext = true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }

                // Nothing matched, or the last one matched, so return the first.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return first;
        }
    }, {
        key: 'getPreviousOption',
        value: function getPreviousOption() {
            // As we iterate through the options, we will constantly be keeping track of the last option
            // visited so that when we find the currently-selected option, we can return the one
            // previous to it.
            var previous = null;

            // Iterate through all options in category order in order to find the current one and select
            // the next one hit.
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = Object.values(this.state.categorisedOptions)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var options = _step4.value;
                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                        for (var _iterator5 = options[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var option = _step5.value;

                            // if the current option is the currently selected one, return the previous option.
                            if (previous && this.state.focussedOption && option.value === this.state.focussedOption.value) {
                                return previous;
                            }

                            // Otherwise, store the current option as the previous one and continue iteration.
                            previous = option;
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                            }
                        } finally {
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }

                // Nothing matched, or the last one matched, so return the last one.
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return previous;
        }

        /*
         * Focus on the next option or first one if none.
         */


        /*
         * Focus on the previous optionof last one if none.
         */


        /*
         * Submit the value that is currently focussed
         */


        /*
         * Adjust the scroll value of the option list to show the selected item
         */


        /*
         * Get the placeholder when there's no options, depending on whether
         * it's a search select or standard fixed list
         */

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            // displayValue is just concerned with what should be displayed, not what we should be
            // using to search on, also we don't care about the inputValue if it is empty - in that
            // case we prefer the currently selected value (if it exists)
            var displayValue = '';
            var actualValue = this.props.value;

            if (this.state.inputValue === null) {
                displayValue = this.getOptionLabelForValue(this.props.value);
            } else {
                displayValue = this.state.inputValue;
            }

            // Ensure the values we will place in the inputs are usable strings (i.e. not null)
            if (!(displayValue && displayValue.length)) {
                displayValue = '';
            }

            if (!(actualValue && actualValue.length)) {
                actualValue = '';
            }

            // Define the classes for the form group
            var groupClasses = (0, _classnames2.default)({
                'form__group': true,
                'form__group--error': this.props.errors && this.props.errors.length
            }, this.props.extraGroupClasses);

            // Define the classes for the form control
            var controlClasses = (0, _classnames2.default)('form__control', 'form__control--select', this.props.controlClassName, 'control-select', {
                'form__control--select-arrow-suffix': this.props.suffix,
                'form__control--input-addon': this.props.prefix || this.props.suffix,
                'control-select--focus': this.state.open
            });

            // Define the position of the option list
            var optionsStyle = {
                userSelect: 'none'
            };

            if (this.state.tooltipPosition) {
                optionsStyle.top = this.state.tooltipPosition;
            }

            // If the implementor thinks the dropdown should take up space in the UI, override its
            // position to static (as it is `absolute` by default in order to make it overlay the
            // content).
            if (this.props.dropdownTakesSpace === true) {
                optionsStyle.position = 'static';
            }

            // Define the list of options available to choose from
            var optionList = null;

            if (this.state.open) {
                if (this.state.numFilteredOptions) {
                    optionList = [];

                    // Now add each category to the optionslist
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        for (var _iterator6 = Object.entries(this.state.categorisedOptions)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var _step6$value = _slicedToArray(_step6.value, 2),
                                category = _step6$value[0],
                                options = _step6$value[1];

                            optionList.push(_react2.default.createElement(
                                'div',
                                { key: category },
                                category !== '__NONE__' && _react2.default.createElement(
                                    'div',
                                    { className: 'control-select__group-heading' },
                                    category
                                ),
                                options.map(function (option) {
                                    var classes = {
                                        'control-select__option': true,
                                        'control-select__option--focused': _this3.state.focussedOption && option.value === _this3.state.focussedOption.value,
                                        'control-select__option--selected': option.value === _this3.props.value
                                    };

                                    if (option.classes) {
                                        classes[option.classes] = true;
                                    }

                                    var optionClasses = (0, _classnames2.default)(classes);

                                    return _react2.default.createElement(
                                        'div',
                                        {
                                            className: optionClasses,
                                            'data-value': option.value,
                                            key: option.value,
                                            onClick: _this3.handleOptionClicked.bind(_this3, option),
                                            onKeyPress: _this3.handleOptionKeyPressed.bind(_this3, option),
                                            tabIndex: '0'
                                        },
                                        option.label
                                    );
                                })
                            ));
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }
                } else {
                    optionList = _react2.default.createElement(
                        'div',
                        { className: 'control-select__option' },
                        this.getNoOptionPlaceholder()
                    );
                }
            }

            var control = _react2.default.createElement(
                'div',
                {
                    className: controlClasses,
                    onBlur: this.handleComponentBlurred,
                    onFocus: this.handleComponentFocussed,
                    ref: this.storeFormControlRef
                },
                _react2.default.createElement('input', {
                    autoComplete: 'off',
                    className: 'form__select',
                    disabled: this.props.disabled,
                    id: this.inputId,
                    onChange: this.handleInputChanged,
                    onKeyDown: this.handleInputKeyDown,
                    onMouseDown: this.handleInputMousePressedDown,
                    placeholder: this.props.placeholder,
                    ref: this.storeTextInputRef,
                    type: this.props.type || 'text',
                    value: displayValue
                }),
                this.props.value && this.props.value.length > 0 && _react2.default.createElement(
                    'button',
                    {
                        className: 'control-select__clear-button',
                        onMouseDown: this.clearSelection,
                        type: 'button'
                    },
                    '×'
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'control-select__options',
                        ref: this.storeOptionListRef,
                        style: optionsStyle
                    },
                    optionList
                ),
                this.props.prefix && _react2.default.createElement(
                    'div',
                    { className: 'input-addon input-addon--prefix' },
                    this.props.prefix
                ),
                this.props.suffix && _react2.default.createElement(
                    'div',
                    { className: 'input-addon input-addon--suffix' },
                    this.props.suffix
                )
            );

            if (this.props.controlOnly) {
                return control;
            }

            return _react2.default.createElement(
                'div',
                { className: groupClasses },
                _react2.default.createElement(
                    _Label2.default,
                    { htmlFor: this.inputId },
                    this.props.label
                ),
                control,
                _react2.default.createElement(_SubContent2.default, { errors: this.props.errors, help: this.props.help })
            );
        }
    }]);

    return Select;
}(_react.Component);

Select.propTypes = _extends({}, _Utils.formControlPropTypes, _Utils.hasOptionsPropTypes, _Utils.focussablePropTypes, {

    categoriseBy: _propTypes2.default.string,
    closeOnSelect: _propTypes2.default.bool,
    controlClassName: _propTypes2.default.string,
    controlOnly: _propTypes2.default.bool,
    defaultOptions: _propTypes2.default.array,
    dropdownTakesSpace: _propTypes2.default.bool,
    filterStartsWithOnly: _propTypes2.default.bool,
    getFilteredOptions: _propTypes2.default.func,
    helpOnFocus: _propTypes2.default.bool,
    innerRef: _propTypes2.default.func,
    minCharSearch: _propTypes2.default.number,
    noOptionPlaceholder: _propTypes2.default.node,
    noResultsPlaceholder: _propTypes2.default.node,
    placeholder: _propTypes2.default.string,
    searchDebounceMs: _propTypes2.default.number,
    searchOptions: _propTypes2.default.func,
    searchingPlaceholder: _propTypes2.default.node,
    type: _propTypes2.default.string
});
Select.defaultProps = {
    closeOnSelect: true,
    controlOnly: false,
    defaultOptions: [],
    disabled: false,
    dropdownTakesSpace: false,
    filterStartsWithOnly: false,
    helpOnFocus: true,
    minCharSearch: 3,
    noOptionPlaceholder: 'No options available',
    noResultsPlaceholder: 'No results found',
    placeholder: 'Select item',
    searchDebounceMs: 250,
    searchingPlaceholder: _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('span', { className: 'loader loader--small' }),
        ' Searching...'
    ),
    value: null
};
Select.createHighlightNode = createHighlightNode;
exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/Select.js
// module id = 264
// module chunks = 0